import { render, staticRenderFns } from "./ChangeCouvertureRecipeModal.vue?vue&type=template&id=22887d8c&scoped=true"
import script from "./ChangeCouvertureRecipeModal.vue?vue&type=script&lang=js"
export * from "./ChangeCouvertureRecipeModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeCouvertureRecipeModal.vue?vue&type=style&index=0&id=22887d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22887d8c",
  null
  
)

export default component.exports